import { initAlpine } from '~lib/storefront';
import './globals';
import './pages/default';
import './styles/style.less';

initAlpine();
